import React from 'react';
import { useField } from 'formik';
import { FormControlLabel, Switch } from '@mui/material';

const MySwitchInput = ({ label, disabled = false, ...props }) => {

    const [field, meta, helpers] = useField(props);

    const handleChange = (event) => {
        const value = event.target.checked ? 1 : 0;
        helpers.setValue(value);
    };

    return (

        <FormControlLabel
            control={
                <Switch
                    checked={Boolean(field.value)}
                    onChange={handleChange}
                    disabled={disabled}
                    color="primary"
                />
            }
            label={label}
        />

    )

}

export default MySwitchInput